module.exports = __webpack_public_path__ + "static/three_phones-ae6a5cbeb946ae12a92f59e5b935cb2a.png";